import { Container, Text, useMantineTheme } from "@mantine/core";

import { HTML_PAGE_NOT_AVAILABLE } from "_constants";

import { PlayBingoGameLoader } from "bingo/play/components/PlayBingoGameLoader";
import PlayHtmlPageView from "./PlayHtmlPageView";
import { withDebug } from "common/debug/components/withDebug";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";
import { useLocation, useParams } from "react-router-dom";
import { useSavedEvent } from "event/hooks/useSavedEvent";
import type { Event } from "event/types/event.model";
import { useSavedBingoGame } from "bingo/hooks/useSavedBingoGame";
import { useHTMLPage } from "htmlpage/hooks/useHTMLPage";
//import { useGetPlayerQuery } from "quiz/api/players.endpoints";

function PlayHtmlPagePresenterComponent() {
  const htmlPage = useHTMLPage();

  const location = useLocation();
  const _state = location.state as { event?: Event } | undefined;
  const event = _state?.event;
  const savedEvent = useSavedEvent(event?.id || "")[0];
  const { htmlPageId } = useParams();
  const [savedGame] = useSavedBingoGame(htmlPageId!);

  const theme = useMantineTheme();

  //const [gameState, setGameState] = useState<GameState | undefined>();
  let playerId: string;
  let partitionId: string;

  if (savedEvent) {
    ({ playerId, partitionId } = savedEvent);
  } else {
    ({ playerId, partitionId } = savedGame || {});
  }
  console.log(playerId);
  console.log(partitionId);
  console.log("playerInfo", savedEvent?.playerInfo);

  const payload = savedEvent?.playerInfo;
  // const { data: playerEventData } = useGetPlayerQuery([playerId, partitionId]);
  //
  // console.log(theme.fontFamily);
  if (htmlPage) {
    return (
      <div style={{ fontFamily: theme.fontFamily }}>
        <PlayHtmlPageView
          htmlPage={htmlPage}
          playerId={playerId}
          partitionId={partitionId}
          playerInfo={payload}
        />
      </div>
    );
  }

  if (!htmlPage) {
    return (
      <Container pb={"lg"}>
        <PlayBingoGameLoader
          message={
            <Text
              className="text-2xl text-center"
              sx={{
                color: DEFAULT_WHITE_COLOR,
                fontFamily: theme.fontFamily,
              }}
              dangerouslySetInnerHTML={{ __html: HTML_PAGE_NOT_AVAILABLE }}
            />
          }
        />
      </Container>
    );
  }

  // if (!bingoGame) {
  //   return <PlayBingoGameView bingoGame={data} />;
  // }

  // Handle the case where data is null but not loading
  return (
    <Container pb={"lg"}>
      <PlayBingoGameLoader
        message={
          <Text
            className="text-2xl text-center"
            sx={{
              color: DEFAULT_WHITE_COLOR,
              fontFamily: theme.fontFamily,
            }}
            dangerouslySetInnerHTML={{ __html: HTML_PAGE_NOT_AVAILABLE }}
          />
        }
      />
    </Container>
  );
}

export const PlayHtmlPagePresenter = withDebug(PlayHtmlPagePresenterComponent);
